import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import * as mockData from '../data/mockData';

const CMSContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK_MAP = {
  company_info: () => mockData.companyInfo,
  hero: () => mockData.hero,
  services: () => mockData.services,
  industries: () => mockData.industries,
  success_stories: () => mockData.successStories,
  blogs: () => mockData.blogs,
  why_choose_us: () => mockData.whyChooseUs,
  stats: () => mockData.stats,
  testimonials: () => mockData.testimonials,
  faqs: () => mockData.faqs,
  about: () => mockData.aboutSection,
  client_logos: () => mockData.clientLogos,
};

export const CMSProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchContent = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/cms/content`);
      setContent(res.data);
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('CMS content fetch failed, using defaults:', err);
      }
      setContent(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  const get = useCallback((section) => {
    if (content && content[section]) return content[section];
    const fallback = FALLBACK_MAP[section];
    return fallback ? fallback() : null;
  }, [content]);

  const value = useMemo(
    () => ({ content, loading, get, refresh: fetchContent }),
    [content, loading, get, fetchContent]
  );

  return <CMSContext.Provider value={value}>{children}</CMSContext.Provider>;
};

export const useCMS = () => useContext(CMSContext);
